export default {"src":"/_next/static/media/ship-skis-text-only-dark.a69ff11b.svg","height":13,"width":54,"blurWidth":0,"blurHeight":0};